export async function configureMemoryPassagePage(doc, person, studyGroup, vts) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginSize = pageWidth * 0.1;
    doc.setTextColor('#333');
    const titleFontSize = 18;
    const verseFontSize = 16;
    const refFontSize = 14;
    const lineSpacing = 8;
    const memoryText = await vts.getVerseText(studyGroup.memoryStartingLocation, studyGroup.memoryEndingLocation);
    const memoryReference = vts.getVerseRangeTitle(studyGroup.memoryStartingLocation, studyGroup.memoryEndingLocation);
    const title = `${person.name} -- Memory Passage`;
    doc.setFontSize(verseFontSize);
    const maxTextWidth = pageWidth - 2 * marginSize;
    const verseLines = doc.splitTextToSize(memoryText, maxTextWidth);
    const titleHeight = titleFontSize;
    const verseHeight = verseFontSize * verseLines.length * 0.5 + lineSpacing * (verseLines.length - 1);
    const refHeight = refFontSize;
    const totalContentHeight = titleHeight + 20 + verseHeight + 15 + refHeight;
    let currentY = (pageHeight - totalContentHeight) / 2;
    doc.setFontSize(titleFontSize);
    doc.setFont('helvetica', 'bold');
    doc.text(title, pageWidth / 2, currentY, { align: 'center' });
    currentY += titleHeight + 20;
    doc.setFontSize(verseFontSize);
    doc.setFont('helvetica', 'normal');
    doc.text(verseLines, pageWidth / 2, currentY, { align: 'center' });
    currentY += verseHeight + 15;
    doc.setFontSize(refFontSize);
    doc.setFont('helvetica', 'italic');
    doc.text(memoryReference, pageWidth / 2, currentY, { align: 'center' });
}
//# sourceMappingURL=pdf-memory-page.js.map